import { FileWithPreview } from "react-dropzone";

export interface IUploadLinesheet {
    id: string;
    fileName: string;
    type: string;
    file: FileWithPreview;
}

export enum CatalogProcessingStatuses {
    // Not processing
    Initial,
    // Catalog is processing
    ProductUpload,
    // Products were added, image scrapping in progress
    ProductsAdded,
}
